import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import { Badge, CustomCheckbox, CustomPanel, Loading, PageHeader } from '../../../../components'
import { showMessageBox } from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import { laranja } from '../../../../assets/js/colors'
import {
  associarNotaFiscalClienteComItems,
  getMissingProductByDeliveryId,
} from '../../../../services/api/https/ordem-coleta/ordem-coleta.http'
import { renderOrdemColetaQuantityCell } from '../ordem-coleta-volume-and-units.helper'

function NotaFiscalClienteItems({ history, dispatch }) {
  // Vars
  const { invoice, delivery_id } = history.location.state

  // Hooks
  const [isLoading, setIsLoading] = useState(true)
  const [items, setItems] = useState([])
  useEffect(() => {
    getItems()
  }, [delivery_id])

  // Events
  const onBtnAssociarClick = async () => {
    try {
      const { invoice_id, invoice_number } = invoice
      const selectedItems = items.filter(i => i.selected)
      if (selectedItems.length === 0) throw new Error('Nenhum item foi selecionado')

      await associarNotaFiscalClienteComItems(
        invoice_id,
        selectedItems.map(i => i.missing_product_id),
      )

      const newItems = [...items]
      selectedItems.forEach(item => {
        const index = newItems.findIndex(n => n.missing_product_id === item.missing_product_id)
        if (index !== -1) {
          newItems[index].selected = false
          newItems[index].invoice_number = invoice_number
        }
      })
      setItems(newItems)
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    }
  }

  const onCheckboxClick = (item, checked) => {
    const index = items.findIndex(i => i.missing_product_id === item.missing_product_id)
    if (index !== -1) {
      const newItems = [...items]
      newItems[index].selected = checked
      setItems(newItems)
    }
  }

  // Helpers
  const getItems = async () => {
    try {
      const fetchedItems = await getMissingProductByDeliveryId(delivery_id)
      setItems(fetchedItems)
      setIsLoading(false)
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    }
  }
  // Render
  return (
    <React.Fragment>
      <PageHeader>
        Associe os Items a Nota Fiscal Nº: &nbsp;
        <strong>{invoice.invoice_number}</strong>
      </PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel
          onVoltar={history.goBack}
          showBtnNovo={true}
          btnLabel="Associar"
          onNovo={onBtnAssociarClick}
        >
          {isLoading ? (
            <div className="text-center">
              <Loading />
            </div>
          ) : (
            <DataTable value={items}>
              <Column
                header="#"
                style={tableCellCentered(80)}
                body={item => (
                  <CustomCheckbox
                    checked={item.selected}
                    onChange={checked => onCheckboxClick(item, checked)}
                  />
                )}
              />
              <Column field="product_code" header="Código" style={tableCellCentered(80)} />
              <Column field="product_name" header="Produto" />
              <Column
                field="qte_faltas"
                header="Qte. Faltas"
                style={tableCellCentered(110)}
                body={item => renderOrdemColetaQuantityCell(item, item.qte_faltas)}
              />
              <Column field="reason" header="Motivo" />
              <Column field="stage" header="Etapa" style={tableCellCentered()} />
              <Column
                field="invoice_number"
                header="Nº Nota Fiscal"
                style={tableCellCentered()}
                body={item => {
                  return item.invoice_number ? (
                    <Badge color={laranja}>{item.invoice_number}</Badge>
                  ) : null
                }}
              />
            </DataTable>
          )}
        </CustomPanel>
      </div>
    </React.Fragment>
  )
}

export default connect()(withRouter(NotaFiscalClienteItems))
